<ng-container *ngComponentOutlet="badgeComponents[badgeType]; injector: injector; inputs: { topic: asset }" />
